module.exports = __webpack_public_path__ + "img/grid2.2ac81de3.jpg";